import * as Yup from 'yup';
import { requiredField } from './utils/messages';

export const exampleValidationSchema = Yup.object().shape({
  // name: Yup.string().required(requiredField),
  // password: Yup.string()
  //   .required(requiredField)
  //   .oneOf([Yup.ref('confirmPassword'), null], passwordNotMatch),
  // confirmPassword: Yup.string()
  //   .required(requiredField)
  //   .oneOf([Yup.ref('password'), null], passwordNotMatch),
  // select: Yup.string().required(requiredField),
  // text: Yup.string().max(5, 'Tamanho excedido'),
  // date: Yup.string().required(),
  radio_value: Yup.string().required(requiredField),
});
